import React, { useState } from "react";
import styles from "./Withdrawal.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import secureLocalStorage from "react-secure-storage";
import Select, { components } from "react-select";
import axios from "axios";
import { colourStylesCurrency } from "../../components/SelectCurrencyStyles";
import { networkTypes } from "../../constants/constants";

export default function Withdrawal({
  theme,
  account,
  accounts,
  setSnackType,
  setSnackMessage,
  handleClick,
  handleSetDrawerWithdrawal,
  usdToEur,
  AccountTypeEnum,
}) {
  const { t } = useTranslation();
  const [withdrawalType, setWithdrawalType] = useState(1);
  const [amount, setAmount] = useState("");
  const [fullname, setFullName] = useState("");
  const [network, setNetwork] = useState("");
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [creditCard, setCreditCard] = useState("");
  const { id } = useParams();
  const Withdrawal = async () => {
    if (!withdrawalType) {
      handleClick();
      setSnackType("error");
      setSnackMessage(t("WithdrawalTypeError"));
      return;
    }
    if (!creditCard) {
      handleClick();
      setSnackType("error");
      setSnackMessage(t("WithdrawalNumberError"));
      return;
    }
    if (withdrawalType === 2 && !network) {
      handleClick();
      setSnackType("error");
      setSnackMessage(t("WithdrawalNetworkError"));
      return;
    }
    if (withdrawalType !== 2 && !fullname) {
      handleClick();
      setSnackType("error");
      setSnackMessage(t("WithdrawalNameError"));
      return;
    }

    if (!amount || amount < 0) {
      handleClick();
      setSnackType("error");
      setSnackMessage(t("WithdrawalAmountInvalid"));
      return;
    }
    if (
        (account.AccountCurrency === "EUR"
            ? parseFloat(+amount * usdToEur)
            : +amount) > account?.AccountBalance
    ) {
      handleClick();
      setSnackType("error");
      setSnackMessage(t("WithdrawalAmountError"));
      return;
    }

    await axios.post(process.env.REACT_APP_test_url + `/api/contact/email`, {
      headers: {},
      email: secureLocalStorage.getItem("user").Email,
      message:
          "Contact about withdrawal of " + account.AccountCurrency === "EUR"
              ? parseFloat(+amount * usdToEur)
              : +amount + " USD",
      name: `${secureLocalStorage.getItem("user").FirstName} ${
          secureLocalStorage.getItem("user").SecondName
      } ${secureLocalStorage.getItem("user").LastName}`,
      type: withdrawalType == 1
          ? t("Bank Transfer")
          : withdrawalType == 2 ? t("Crypto currency") : t("Card"),
      account: creditCard,
      firstname: secureLocalStorage.getItem("user").FirstName,
      lastname: secureLocalStorage.getItem("user").SecondName,
      platformid: id ? id : account?.Id,
      address: address,
      fullname: fullname,
      price: account?.AccountCurrency === 'EUR' ? parseFloat(+amount * usdToEur) : +amount,
    }).then((result) => {
      navigate("/cabinet");
      setSnackType("success");
      setSnackMessage(t("ManagerWill"));
      handleClick();
      handleSetDrawerWithdrawal();
    }).catch(e => {
      setSnackType("error");
      setSnackMessage(t("Amount Error"));
      handleClick();
    })
  };

  const CustomOption = (props) => {
    const { innerProps, innerRef } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={
          props.isSelected
            ? styles.custom_option_selected
            : styles.custom_option
        }
      >
        <div
          className={styles.option}
          style={{
            color: props.data.color,
            backgroundColor: props.data.background,
            width: "auto",
          }}
        >
          {props.data.label}
        </div>
      </div>
    );
  };

  const DropdownIndicator = ({ children, ...props }) => (
    <components.DropdownIndicator {...props}>
      <div className={styles.single_value_container}>
        <div className={styles.custom_icon}>
          <svg
            width={"1.7vh"}
            height={"1.6vh"}
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5003 6L8.83366 10L4.16699 6"
              stroke="#A0A0AB"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {children}
      </div>
    </components.DropdownIndicator>
  );
  const types = [
    { value: 1, label: t("Bank Transfer") },
    { value: 2, label: t("Crypto currency") },
    { value: 3, label: t("Card") },
  ];

  if (account && account.AccountType === AccountTypeEnum.Fake)
    navigate("/cabinet");
  return (
    <div className={styles.withdrawal}>
      <div className={styles.withdrawal_title}>
        <div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M12.6667 9.33325V13.3333M12.6667 13.3333L14 11.9999M12.6667 13.3333L11.3334 11.9999"
                stroke="var(--font-mine)"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.6667 8.00008C14.6667 5.48592 14.6667 4.22885 13.8857 3.4478C13.1046 2.66675 11.8475 2.66675 9.33337 2.66675H6.66671C4.15255 2.66675 2.89547 2.66675 2.11442 3.4478C1.33337 4.22885 1.33337 5.48592 1.33337 8.00008C1.33337 10.5142 1.33337 11.7713 2.11442 12.5524C2.89547 13.3334 4.15255 13.3334 6.66671 13.3334H9.33337"
                stroke="var(--font-mine)"
                stroke-linecap="round"
              />
              <path
                d="M6.66667 10.6667H4"
                stroke="var(--font-mine)"
                stroke-linecap="round"
              />
              <path
                d="M8.66671 10.6667H8.33337"
                stroke="var(--font-mine)"
                stroke-linecap="round"
              />
              <path
                d="M1.33337 6.66675L14.6667 6.66675"
                stroke="var(--font-mine)"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <span>{t("Withdrawal")}</span>
        </div>
        <button
          onClick={handleSetDrawerWithdrawal}
          className={styles.closeButton}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M12 4.00003L4 12M3.99997 4L11.9999 12"
              stroke="var(--font-mine)"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div className={styles.withdrawal_body}>
        <div className={styles.withdrawal_form}>
          <div className={styles.select}>
            <Select
              classNamePrefix="custom_select"
              className={`${styles.select_select} custom-select-container`}
              placeholder={t("Currency")}
              menuPlacement="auto"
              options={types}
              styles={colourStylesCurrency(theme)}
              components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
                Option: CustomOption,
              }}
              value={types.find((el) => el.value === withdrawalType)}
              onChange={(selectedOption) =>
                setWithdrawalType(selectedOption.value)
              }
            />
          </div>
          <div className={styles.amount}>
            <label>{t("Amount of payment")}</label>
            <input
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || /^\d*([.,]\d{0,2})?$/.test(value)) {
                  setAmount(value.replace(",", "."));
                }
              }}
              value={amount}
              placeholder={t("Amount of payment")}
              type="text"
              inputMode="decimal"
            />
          </div>
          {withdrawalType === 3 ? (
            <div className={styles.amount}>
              <label>{t("Credit card")}</label>
              <InputMask
                mask="9999 9999 9999 9999"
                maskChar="*"
                value={creditCard}
                onChange={(e) => setCreditCard(e.target.value)}
              >
                {(inputProps) => (
                  <input
                    {...inputProps}
                    placeholder={t("Credit card")}
                    type="text"
                  />
                )}
              </InputMask>
            </div>
          ) : withdrawalType === 1 ? (
            <div className={styles.amount}>
              <label>{t("IBAN")}</label>
              <input
                placeholder={t("IBAN")}
                type="text"
                value={creditCard}
                onChange={(e) => setCreditCard(e.target.value)}
              />
            </div>
          ) : (
            <div className={styles.amount}>
              <label>{t("Crypto Wallet")}</label>
              <input
                placeholder={t("Crypto Wallet")}
                type="text"
                value={creditCard}
                onChange={(e) => setCreditCard(e.target.value)}
              />
            </div>
          )}
          {withdrawalType === 2 ? (
            <div className={styles.select}>
              <label>{t("Network type")}</label>
              <Select
                classNamePrefix="custom_select"
                className={`${styles.select_select} custom-select-container`}
                placeholder={t("Network type")}
                menuPlacement="auto"
                options={networkTypes}
                styles={colourStylesCurrency(theme)}
                components={{
                  DropdownIndicator,
                  IndicatorSeparator: () => null,
                  Option: CustomOption,
                }}
                value={networkTypes.find((el) => el.value === network)}
                onChange={(selectedOption) => setNetwork(selectedOption.value)}
              />
            </div>
          ) : (
            <div className={styles.amount}>
              <label>{t("Full name")}</label>
              <input
                onChange={(e) => setFullName(e.target.value)}
                value={fullname}
                placeholder={t("Full name")}
                type="text"
              />
            </div>
          )}
          {withdrawalType !== 2 && (
            <div className={styles.amount}>
              <label>{t("Recipient address")}</label>
              <input
                onChange={(e) => setAddress(e.target.value)}
                value={address}
                placeholder={t("Recipient address")}
                type="text"
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.buttons}>
        <button onClick={handleSetDrawerWithdrawal}>{t("Cancel")}</button>
        <button
          onClick={() => {
            Withdrawal();
            handleSetDrawerWithdrawal();
          }}
        >
          {t("Continue")}
        </button>
      </div>
    </div>
  );
}
